import fileDownload from 'js-file-download';
import { Buffer } from 'buffer';

export default class FileApi {
    static download(fileId, title, saveToLog) {
        return axios => axios
            .get(`/files/download/${fileId}/${saveToLog ? 1 : 0}`)
            .then((response) => {
                const buffer = new Buffer(response.data.Body.data, 'binary');
                fileDownload(buffer, title);
            });
    }
}



// WEBPACK FOOTER //
// ./src/api/file.js